import type { ColumnFilterType } from "./data-table";
import { DateFilterInput } from "./filters/DateFilterInput";
import {
  type IFilterOption,
  MultiSelectFilterInput,
} from "./filters/MultiSelectFilterInput";
import { NumberRangeFilterInput } from "./filters/NumberRangeFilterInput";
import { TextFilterInput } from "./filters/TextFilterInput";
import type { ColumnFilter } from "./filters/types";

interface IFilterEditorProps {
  filterType: ColumnFilterType;
  filterOptions?: IFilterOption[];
  /** Placeholder for a text filter's search box; TextFilterInput's default when omitted. */
  filterPlaceholder?: string;
  value: ColumnFilter | undefined;
  onChange: (value: ColumnFilter | undefined) => void;
}

export function FilterEditor({
  filterType,
  filterOptions,
  filterPlaceholder,
  value,
  onChange,
}: IFilterEditorProps) {
  if (filterType === "text")
    return (
      <TextFilterInput
        value={value?.type === "text" ? value : undefined}
        onChange={onChange}
        placeholder={filterPlaceholder}
      />
    );

  if (filterType === "date")
    return (
      <DateFilterInput
        value={value?.type === "date" ? value : undefined}
        onChange={onChange}
      />
    );

  if (filterType === "multiSelect")
    return (
      <MultiSelectFilterInput
        value={value?.type === "multiSelect" ? value : undefined}
        onChange={onChange}
        options={filterOptions ?? []}
      />
    );

  if (filterType === "numberRange")
    return (
      <NumberRangeFilterInput
        value={value?.type === "numberRange" ? value : undefined}
        onChange={onChange}
      />
    );

  return null;
}
